import styled from 'styled-components'

type PainAlertChipProps = {
  noPadding?: boolean
}

export const PainAlertChip = styled.div<PainAlertChipProps>`
  display: flex;
  padding: ${({ noPadding }) => (noPadding ? '6px 6px' : '0px 16px')};
  background-color: ${({ theme }) => theme.colors.alert};
  color: ${({ theme }) => theme.colors.white};
  border-radius: ${({ theme }) => theme.border.radius.large};
  align-items: center;
  font-size: ${({ theme }) => theme.font.sizes.xsmall};
  gap: 5px;
  margin-left: 12px;
`

export const BreathingDifficultyWrapper = styled.div`
  display: flex;
  gap: 15px;
  flex-wrap: wrap;
  margin-top: 10px;
`
